module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid45_980x863.70e0d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid45_980x863.jpg
// module id = I6Nw
// module chunks = 0